import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import { useSelector } from 'react-redux';
import DeviceTypeTableService from '../service/DeviceTypeTableService';

const config = data => {
	return {
		key: 'deviceTypeTable',
		text: 'Device type',
		textKey: 'deviceType',
		service: DeviceTypeTableService,
		editFormState: item => `/device-type/edit/${item ? item.id : 'new'}`,
		toolbarAction: data.user.isSuperAdmin ? ['filter', 'search', 'refresh', 'new'] : ['search', 'refresh', 'new'],
		rowAction: ['modify', 'delete'],
		filterFields: [
			{
				propertyName: 'project',
				text: 'Project',
				propertyType: 'Long',
				type: 'IN',
				visibleIf: () => data.user.isSuperAdmin
			}
		],
		columns: [
			{
				key: 'name',
				text: 'Name',
				textKey: 'name',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'sensorTypeList',
				text: 'Sensor types',
				textKey: 'sensorTypeList',
				type: 'text',
				sortable: false,
				disablePadding: false
			},
			/*{
				key: 'bridge',
				text: 'Bridge',
				textKey: 'bridge',
				type: 'boolean',
				sortable: true,
				disablePadding: false
			},*/
			/*{
				key: 'canRecord',
				text: 'Can Record?',
				textKey: 'canRecord.name',
				type: 'boolean',
				sortable: true,
				disablePadding: false
			},*/
			{
				key: 'externalId',
				text: 'External ID',
				textKey: 'externalId',
				type: 'text',
				sortable: true,
				disablePadding: false
			}
			/*{
				key: 'project.name',
				text: 'Project',
				textKey: 'project.name',
				type: 'text',
				sortable: true,
				disablePadding: false
			}*/
		]
	};
};

function DeviceTypeTable() {
	const selectedDevice = useSelector(({ device }) => device.selection.selectedDevice);
	const user = useSelector(({ auth }) => auth.user);
	const myConfig = config({ user });

	return <TableBrowser config={myConfig} />;
}

export default withReducer('deviceTypeTable', reducer('deviceTypeTable'))(DeviceTypeTable);
